import { firebase } from 'config';
import { Lead, LeadsService } from 'types';

const leadsService: LeadsService = {
  saveLead: (lead, onComplete) => {
    return firebase
      .database()
      .ref('/leads')
      .push({ date: Date.now(), ...lead }, onComplete);
  },
  fetchLead: (leadId) => {
    return firebase.database().ref(`/lead/${leadId}`).get().then(snap => {
      const data: Lead = snap.val();
      return { id: leadId, ...data };
    });
  },
  fetchLeads: () => {
    return firebase
      .database()
      .ref('/leads')
      .get()
      .then(snap => {
        const data: { [leadId: string]: Lead } = snap.val();
        return Object.values(data).map((lead: Lead, i) => ({
          id: Object.keys(data)[i],
          ...lead,
        }));
      });
  },
  removeLead: (lead) => {
    console.log(lead)
    return firebase
      .database()
      .ref(`/lead/${lead.id}`)
      .remove()
      .then(() => {
        firebase
          .database()
          .ref(`/removed/${lead.id}`)
          .set(lead);
      });
  },
};

export default leadsService;